/* eslint-disable no-empty */
document.addEventListener('DOMContentLoaded', function () {//eslint-disable-line
	const successMsg = document.getElementById('contact-form-success-header');
	if (successMsg) {
		successMsg.textContent = 'Thanks! We’ll be in touch soon';
	}
	const yes = document.querySelectorAll('.is-style-button');
	const reverse = document.querySelectorAll('.reverse-div .wp-block-group__inner-container')[0];
	try {
		document.querySelectorAll('.no-parameter')[0].style.display = 'none';
		document.querySelectorAll('.yes-parameter')[0].style.display = 'none';
		document.querySelectorAll('.reverse-div')[0].style.display = 'none';
		document.querySelectorAll('.wp-block-jetpack-button')[0].style.display = 'none';
	} catch (e) {}

	yes.forEach(people => {
		people.addEventListener('click', function () {//eslint-disable-line
			const textLabel = document.querySelector('.field-label-class-wrap').querySelector('label');
			if (people.value === 'Yes') {
				textLabel.textContent = 'Anything else you want to tell us?';
				document.querySelectorAll('.wp-block-jetpack-button')[0].style.display = 'block';
				document.querySelectorAll('.reverse-div')[0].style.display = 'block';
				document.querySelectorAll('.no-parameter')[0].style.display = 'none';
				document.querySelectorAll('.yes-parameter')[0].style.display = 'block';
				reverse.setAttribute('style', 'flex-direction: column-reverse;display: block;');
			} else {
				textLabel.textContent = 'What pain are you experiencing in digital?';
				document.querySelectorAll('.wp-block-jetpack-button')[0].style.display = 'block';
				document.querySelectorAll('.reverse-div')[0].style.display = 'block';
				document.querySelectorAll('.no-parameter')[0].style.display = 'block';
				document.querySelectorAll('.yes-parameter')[0].style.display = 'none';
				reverse.setAttribute('style', 'flex-direction: column-reverse;display: flex;');
			}
		});
	});
	const mediaQuery = window.matchMedia('(max-width: 768px)');
	if (mediaQuery.matches) {
		const painPoint = document.querySelector('.grunion-field-radio-wrap');
		const toggleClass = 'sticky-top';
		window.addEventListener('scroll', () => {
			const currentScroll = window.pageYOffset;
			if (currentScroll > 200) {
				painPoint.classList.add(toggleClass);
			} else {
				painPoint.classList.remove(toggleClass);
			}
		});
	}
});
